var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v("The requested page was not found.")])])}
var staticRenderFns = []

export { render, staticRenderFns }